


export default {
  SelUser: () => import('./components/sysconfig/SelectUser.vue'),//选择用户
  newSelComponent: () => import('./components/sysconfig/newSelComponent.vue'),//选择构件
  CategoryLeft: () => import('./components/leftComponents/CategoryLeft.vue'),//左侧机构树
  CategoryLeftStruct: () => import('./components/leftComponents/CategoryLeftStruct.vue'),//左侧选单位工程列表
  gjCategoryLeftStruct: () => import('./components/leftComponents/gjCategoryLeftStruct.vue'),//左侧选单位工程构件树
  SelPersonLabor: () => import('./components/sysconfig/selPersonLabor.vue'),
  newSelComponentFree: () => import('./components/sysconfig/newSelComponent_free.vue'),//多选WBS
  MemberSelector: () => import('./components/bizselectecom/selectPerson.vue'),//新劳务人员选择 布局显示结果不好找，暂时停止使用
  MemberTreeSelector: () => import('./components/bizselectecom/selectTreeperson.vue'),// 左侧树新劳务人员选择 selectTreeperson
  MemberTreeSelectorOAks: () => import('./components/bizselectecom/selectTreepersonOAks.vue'),// OA考试左侧树新劳务人员选择 selectTreeperson
  WorkPlace: () => import('./components/integrated/workPlaceSel.vue'),//工点选择组件
  SelectInstitution: () => import('./components/sysconfig/SelectInstitution.vue'),//机构选择
  DataStructureTree: () => import('./components/leftComponents/DataStructureTree.vue'),//构件类别树
  CurrentUnitStruct: () => import('./components/leftComponents/CurrentUnitStruct.vue'),//选择线路单位工程
  SelectUnitStruct: () => import('./components/bizselectecom/SelectUnitStruct.vue'), // 批量选择单位工程
  roadLineCategory: () => import('./components/roadLine-category.vue'), // 线路及构件类别
  TjMemberTreeSelector: () => import('./components/bizselectecom/TjSelectTreeperson.vue'),// tj左侧树新劳务人员选择
  SelJLXXHUser: () => import('./components/sysconfig/SelJLXXHUser.vue'),//选择监理信息化用户
  SelUserDbCenter: () => import('./components/sysconfig/SelectUserDbCenter.vue'),//选择用户(数据中心使用)

}


